import styled from 'styled-components'

import { fontWeight, color } from 'src/styles'
import { fontSize } from 'src/styles/fonts'

export const PercentWrap = styled.span`
  font-size: initial;
  color: initial;
  font-weight: ${fontWeight.EXTRA};
  margin-right: 3rem;
`

export const SpacingWrap = styled.div`
  margin-left: 1.6rem;
`

export const GrayButtonLink = styled.span<{ secondary?: boolean }>`
  padding: 0.8rem 2.2rem;
  line-height: 1;
  color: ${({ secondary }) => (secondary ? color.WARM_GREY : color.WHITE)};
  background-color: ${({ secondary }) =>
    secondary ? 'rgba(87, 61, 57, 0.15)' : color.DUSTY_ORANGE};
  font-weight: ${fontWeight.EXTRA};
  border-radius: 2.4rem;
  font-size: ${fontSize.NORMAL};
  white-space: nowrap;
`
